import React, { useState } from 'react';
import { PlusIcon, XIcon } from 'lucide-react';
export function HesitationsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'Q: "Will it interfere with my phone\'s performance?"',
    answer: "A: No. The stickers don't block signals; they absorb radiation on the surface. Your phone works exactly the same. Wireless charging, Bluetooth, cellular signal—all unaffected."
  }, {
    question: 'Q: "Is this proven to improve health?"',
    answer: "A: Radiation reduction is proven (measurable). Health benefits are less certain. What we know: 73% of users report sleep improvement, 68% report improved focus. Whether that's from reduced EMF or placebo, if you sleep better and think more clearly, does the mechanism matter?"
  }, {
    question: 'Q: "What if I don\'t notice a difference?"',
    answer: "A: That's why we offer a 90-day money-back guarantee. Measure the radiation reduction with a meter. If you're not satisfied, return them for full refund. No questions asked."
  }, {
    question: 'Q: "Can\'t I just limit screen time instead?"',
    answer: "A: You should. But limiting screen time doesn't eliminate EMF exposure (WiFi routers, smart meters, 5G towers transmit 24/7 regardless). Screen time limits reduce usage-based exposure; stickers reduce ambient exposure. Both together are more complete."
  }, {
    question: 'Q: "Will my family think I\'m paranoid?"',
    answer: "A: Stickers are invisible. Nobody sees them. Your family won't know unless you tell them. And if they do? 15,000+ Australian families have done this—they're not fringe anymore. They're normal."
  }];
  return <section id="faq" className="w-full py-8 md:py-12 lg:py-16 px-4 md:px-6 border-t-2" style={{
    backgroundColor: '#F8F9FA',
    borderColor: '#1B4F9E',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-49">
      <div className="max-w-[900px] mx-auto" data-id="element-50">
        <h2 className="text-[29px] md:text-[34px] lg:text-[43px] font-bold mb-10 text-center" style={{
        color: '#1B4F9E'
      }} data-id="element-51">
          ADDRESSING YOUR LAST HESITATIONS
        </h2>

        <div className="bg-white rounded-lg border overflow-hidden" style={{
        borderColor: '#E0E4E8'
      }} data-id="element-52">
          {faqs.map((faq, index) => <div key={index} className="border-b last:border-b-0" style={{
          borderColor: '#E0E4E8'
        }} data-id="element-53">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left transition-colors duration-200 hover:bg-[#F0F7FF]" data-id="element-54">
                <span className="text-base font-semibold pr-4" style={{
              color: '#1B4F9E'
            }} data-id="element-55">
                  {faq.question}
                </span>
                <span className="flex-shrink-0 transition-transform duration-300" style={{
              color: '#1B4F9E',
              transform: openIndex === index ? 'rotate(45deg)' : 'rotate(0deg)'
            }} data-id="element-56">
                  <PlusIcon className="w-6 h-6" data-id="element-57" />
                </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-58">
                <p className="px-5 md:px-6 pb-5 md:pb-6 text-[15px]" style={{
              color: '#2C3E50'
            }} data-id="element-59">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}